/* eslint-disable no-param-reassign */
import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import configDB from 'data/customizer/config';
import { getFromLocalStorage, token } from 'localStorageService/LocalStorage';
// actions
import { setAllDeliverySlots } from 'store/delivery/deliverySlots/slotsActions';
import { getInventoryData } from 'store/inventory/InventoryActions';
import { getCategoriesData } from 'store/categories/CategoriesActions';
// selector
import { filterQuickActions } from 'store/orderQuickActions/dataTable/DataTableAction';
import { getPermissionsList } from 'store/app/AppSelectors';
// constants
import { MENUITEMS } from './menu';
import { convertObjectIntoQueryParams, HasPermission } from 'constant/Helpers';
import { localStorageKeys } from 'constant/Enums';
import {
  getOrderQuickActionsPageUrl,
  getPremiumQuickActionsPageUrl,
  getCategoriesPage,
} from 'constant/AppUrls';
import { setBaseUrl } from 'services/apiService/SetBaseUrl';
import { initialPayload } from 'constant/filteInputs';
// components
import PermissionedSubMenuItem from './menuItems/PermissionedSubMenuItem';
import SubMenuItem from './menuItems/SubMenuItem';
import PermissionedMenuItem from './menuItems/PermissionedMenuItem';
import MenuItem from './menuItems/MenuItem';
import ClickAwayListener from '@mui/base/ClickAwayListener';
import RestrictedSection from 'components/shared/RestrictedSection';
import PermissionedSubSubMenu from './menuItems/PermissionedSubSubMenu';
// api
import TicketingService from 'services/TicketingService';
import InventoryService from 'services/InventoryService';

const Sidebar = (props) => {
  const [margin, setMargin] = useState(0);
  const [width, setWidth] = useState(0);
  const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(true);
  const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
  const [hideRightArrow, setHideRightArrow] = useState(true);
  const [hideLeftArrow, setHideLeftArrow] = useState(true);
  const [mainmenu, setMainMenu] = useState(MENUITEMS);
  const wrapper = configDB.data.settings.sidebar.wrapper;
  const layout = useSelector((content) => content.Customizer.layout);
  const [ticketsList, setTicketsList] = useState([]);
  const [alertQtyItems, setAlertQtyItem] = useState([]);
  const [displayVal, setDisplayVal] = useState('none');
  const permissionsList = useSelector((state) => getPermissionsList({ state }));
  const base = setBaseUrl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const opsId = getFromLocalStorage(localStorageKeys.OPS_ID);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    const currentUrl = window.location.pathname;

    // eslint-disable-next-line
    mainmenu.filter((items) => {
      if (items.path === currentUrl) setNavActive(items);
      if (!items.children) return false;
      // eslint-disable-next-line
      items.children.filter((subItems) => {
        if (subItems.path === currentUrl) setNavActive(subItems);
        if (!subItems.children) return false;
        // eslint-disable-next-line
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === currentUrl) {
            setNavActive(subSubItems);
            return true;
          } else {
            return false;
          }
        });
        return subItems;
      });
      return items;
    });

    const timeout = setTimeout(() => {
      const elmnt = document.getElementById('myDIV');
      const menuWidth = elmnt.offsetWidth;
      if (menuWidth > window.innerWidth) {
        setHideRightArrow(false);
        setHideLeftArrowRTL(false);
      } else {
        setHideRightArrow(true);
        setHideLeftArrowRTL(true);
      }
    }, 500);

    return () => {
      // eslint-disable-next-line
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeout);
    };
    // eslint-disable-next-line
  }, []);

  const fetchTicketsData = async (params) => {
    try {
      const res = await TicketingService.getTicketsList(params);
      setTicketsList(res.data.data);
    } catch (err) {
      // console.log(err);
    }
  };

  const fetchInventoryAlertStatus = async () => {
    try {
      const res = await InventoryService.getAlertQtyStatus();
      setAlertQtyItem(res.data);
    } catch (err) {
      // console.log(err);
    }
  };

  const fetchStatuses = async () => {
    const promisesArray = [
      fetchTicketsData({
        opsid: getFromLocalStorage(localStorageKeys.OPS_ID),
        page: 1,
      }),
      fetchInventoryAlertStatus(),
    ];
    await Promise.all(promisesArray);
  };

  useEffect(() => {
    // Disable inventory and ticket api call on all pages
    // fetchStatuses();
    setAlertQtyItem(true);
    setTicketsList([{ status: 1 }]);
  }, []);

  const handleResize = () => {
    setWidth(window.innerWidth - 310);
  };

  const setNavActive = (item) => {
    // eslint-disable-next-line
    MENUITEMS.filter((menuItem) => {
      // eslint-disable-next-line
      if (menuItem != item) menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item)) menuItem.active = true;
      if (menuItem.children) {
        // eslint-disable-next-line
        menuItem.children.filter((submenuItems) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
            return true;
          } else {
            return false;
          }
        });
      }
      return menuItem;
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  // Click Toggle menu
  const toggletNavActive = (item) => {
    if (!item.active) {
      MENUITEMS.forEach((a) => {
        if (MENUITEMS.includes(item)) a.active = false;
        if (!a.children) return false;
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) return false;
          b.children.forEach((c) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
          });
        });
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const scrollToRight = () => {
    const elmnt = document.getElementById('myDIV');
    const menuWidth = elmnt.offsetWidth;
    const temp = menuWidth + margin;
    if (temp < menuWidth) {
      setMargin(-temp);
      setHideRightArrow(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideLeftArrow(false);
    }
  };

  const scrollToLeft = () => {
    // If Margin is reach between screen resolution
    if (margin >= -width) {
      setMargin(0);
      setHideLeftArrow(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrow(false);
    }
  };

  const scrollToLeftRTL = () => {
    if (margin <= -width) {
      setMargin((margin) => (margin += -width));
      setHideLeftArrowRTL(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideRightArrowRTL(false);
    }
  };

  const scrollToRightRTL = () => {
    const temp = width + margin;
    // Checking condition for remaing margin
    if (temp === 0) {
      setMargin(temp);
      setHideRightArrowRTL(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrowRTL(false);
      setHideLeftArrowRTL(false);
    }
  };

  const handleParamsUrl = (orderStatus, premium) => {
    dispatch({
      type: 'SET_ORDER_STATUS',
      payload: orderStatus,
    });
    const updatedParams = { ...initialPayload, orderstatus: orderStatus };
    if (premium) {
      dispatch(filterQuickActions(updatedParams, false, 'premium'));
    } else {
      dispatch(filterQuickActions(updatedParams, false));
    }
  };
  const handleMbsOrdersParams = () => {
    dispatch({
      type: 'SET_ORDER_STATUS',
      payload: 2,
    });
    const updatedParams = { ...initialPayload, orderstatus: 2, isMbsOrder: true };
    dispatch(filterQuickActions(updatedParams, false));
  };

  const handlePreOrdersParams = () => {
    dispatch({
      type: 'SET_ORDER_STATUS',
      payload: 7,
    });
    const updatedParams = { ...initialPayload, orderstatus: 7, isPreorder: true };
    dispatch(filterQuickActions(updatedParams, false));
  };

  const handleCategoryParams = (categoryType) => {
    const queryParams = { type: categoryType };
    dispatch(getCategoriesData(queryParams));
  };

  // time slots
  const handleProdLine = (prodLine) => {
    dispatch(setAllDeliverySlots({ line: prodLine, status: 0 }));
  };

  // inventory
  const handleInventoryStatus = (status) => {
    dispatch(
      getInventoryData({
        type: -1,
        sreackkey: '',
        qty: -1,
        minimumQty: -1,
        status,
        page: 1,
        inventorySorting: 0,
      })
    );
  };

  const getRequiredUrl = (orderStatus) => {
    const updatedParams = { ...initialPayload, orderstatus: orderStatus };
    const queryString = convertObjectIntoQueryParams(updatedParams);

    return `${getOrderQuickActionsPageUrl()}${queryString}`;
  };

  const getPremiumRequiredURL = (orderStatus, orderProdType) => {
    const updatedParams = { ...initialPayload, orderstatus: orderStatus, line: orderProdType };
    const queryString = convertObjectIntoQueryParams(updatedParams);

    return `${getPremiumQuickActionsPageUrl()}${queryString}`;
  };

  const getCategoryRequiredURL = (categoryType) => {
    const updatedParams = { type: categoryType };
    const queryString = convertObjectIntoQueryParams(updatedParams);

    return `${getCategoriesPage()}${queryString}`;
  };

  const getMbsRequiredURL = () => {
    const updatedParams = { ...initialPayload, isMbsOrder: true };
    const queryString = convertObjectIntoQueryParams(updatedParams);

    return `${getOrderQuickActionsPageUrl()}${queryString}`;
  };

  const getPreOrderRequiredURL = () => {
    const updatedParams = { ...initialPayload, orderstatus: 7, isPreorder: true };
    const queryString = convertObjectIntoQueryParams(updatedParams);

    return `${getOrderQuickActionsPageUrl()}${queryString}`;
  };

  const toggleSwitch = () => {
    if (displayVal === 'none') {
      setDisplayVal('block');
    } else {
      setDisplayVal('none');
    }
  };

  const ulClassSidebarMenu = (wrapper, layout, margin) => {
    if (wrapper === 'horizontal_sidebar') {
      if (layout === 'rtl') {
        return { marginRight: margin + 'px' };
      } else {
        return { marginLeft: margin + 'px' };
      }
    } else {
      return { margin: '0px' };
    }
  };

  const ilClassSidebarMenu = (layout, hideLeftArrowRTL, hideLeftArrow) => {
    if (layout === 'rtl') {
      if (hideLeftArrowRTL) {
        return 'd-none';
      } else {
        return '';
      }
    } else {
      if (hideLeftArrow) {
        return 'd-none';
      } else {
        return '';
      }
    }
  };

  const getMenuItemPath = (childrenItem) => {
    if (childrenItem.orderStatus && !childrenItem.orderProdType) {
      return getRequiredUrl(+childrenItem.orderStatus);
    } else {
      if (childrenItem.orderStatus && childrenItem.orderProdType) {
        return getPremiumRequiredURL(+childrenItem.orderStatus, +childrenItem.orderProdType);
      } else {
        if (childrenItem.categoryType) {
          return getCategoryRequiredURL(+childrenItem.categoryType);
        } else {
          if (childrenItem.mbsOrders) {
            return getMbsRequiredURL();
          } else if (childrenItem.preOrders) {
            return getPreOrderRequiredURL();
          } else {
            return childrenItem.path;
          }
        }
      }
    }
  };

  return (
    <Fragment>
      <div className="page-sidebar bg-white light-sidebar ">
        <div
          className="main-header-left"
          style={{
            backgroundColor: localStorage.getItem(localStorageKeys.NAV_BG_COLOR)
              ? getFromLocalStorage(localStorageKeys.NAV_BG_COLOR)
              : '#53a6d6',
          }}
        >
          <div className="logo-wrapper compactLogo">
            <RestrictedSection page="dashboard" action="switch_app">
              <ClickAwayListener onClickAway={() => setDisplayVal('none')}>
                <div className="dropdown switch-to">
                  <button
                    onClick={toggleSwitch}
                    className="btn dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div
                      className={`switch-icon ${
                        displayVal === 'none' ? 'switch-closed' : 'switch-opened'
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        role="presentation"
                      >
                        <path d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z" />
                      </svg>
                    </div>
                  </button>
                  <div
                    style={{ display: displayVal }}
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <div className="switchto-title-div">
                      <h1>Switch to</h1>
                    </div>
                    <RestrictedSection page="dashboard" action="fleet_app">
                      <a
                        className="dropdown-item"
                        href={`${base.fleet}?token=${token}&opsId=${opsId}`}
                      >
                        <img alt="logo" src={require('../../../assets/images/icon.jpg')} />
                        <div className="app-icon-div">
                          <svg
                            width="72"
                            height="72"
                            viewBox="0 0 72 72"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M68.2706 1.05331C60.2316 2.39188 52.5276 6.4076 47.1683 12.7658C46.8333 13.1005 46.4983 13.7698 45.8284 14.439C45.4934 14.7737 45.4936 15.1083 45.1586 15.1083C44.8237 15.4429 44.8236 15.7776 44.4887 15.7776C44.1537 16.1122 43.8187 16.4469 43.8187 17.1161L43.4838 17.4508C43.1489 17.7855 42.8137 18.4547 42.4788 19.124C41.139 21.4665 40.4692 23.8091 39.4643 26.1516C40.4692 26.1516 41.809 25.8169 42.8139 25.4822H43.1487C43.4837 25.4822 43.8187 25.4822 43.8187 25.1476C44.1537 25.1476 44.4887 25.1475 44.4887 24.8129C44.4887 24.4783 44.8235 24.1436 44.8235 23.4743C44.8235 23.1397 45.1585 22.8051 45.4935 22.4705C45.4935 22.1358 45.8285 21.8011 46.1635 21.4665V21.1319C46.1635 20.7973 46.4985 20.4626 46.8334 20.1279L47.1683 19.7933C47.1683 19.4586 47.5032 19.124 47.5032 19.124L47.8383 18.7894C47.8383 18.4547 48.1731 18.4547 48.1731 18.12C48.1731 17.7854 48.5082 17.7855 48.5082 17.4508L48.8431 17.1161C49.178 16.7815 49.513 16.4469 49.8479 16.1123C51.1878 14.439 52.8625 12.7657 54.8723 11.4272C57.8869 9.08467 61.2365 7.41145 64.9211 6.40752C63.2463 12.0965 59.8967 17.4508 55.5423 21.1319C54.5374 21.8012 53.5324 22.8051 52.5275 23.4743C51.8576 23.809 51.5227 24.1437 50.8528 24.4783C50.1828 24.813 49.5129 25.1476 49.178 25.4822H48.8431C48.5081 25.4822 48.1731 25.8169 48.1731 25.8169L47.5032 26.1516H47.1683C46.8333 26.1516 46.8333 26.4861 46.4983 26.4861C46.1634 26.4861 45.8284 26.8208 45.8284 26.8208L45.1586 27.1554C44.8237 27.1554 44.8236 27.1555 44.4887 27.4901H44.1536C42.8137 27.8248 41.4741 28.1593 40.1342 28.1593H39.7992H39.4643H38.7943C38.4594 28.1593 38.4593 28.1593 38.1244 28.1593C37.4545 28.1593 37.1195 28.1593 36.4496 28.1593H36.1147C35.7797 28.1593 35.4448 28.1593 35.1099 28.1593C35.4448 29.8325 35.4447 31.1712 35.7796 32.8444H36.1147C36.7846 32.8444 37.1196 32.8444 37.7895 32.8444H38.1244C38.4593 32.8444 38.7942 32.8444 39.1292 32.8444C39.4642 32.8444 39.7992 32.8444 39.7992 32.8444C40.1341 32.8444 40.8041 32.8444 41.1391 32.5098C42.144 32.5098 43.1487 32.1751 44.1536 31.8404C45.1585 31.5058 46.1633 31.1712 47.5032 30.8365C47.8381 30.8365 48.1732 30.5019 48.5082 30.5019L48.8431 30.1672C51.8577 28.8286 54.8723 27.1554 57.5519 24.8129C57.8869 24.4783 57.8869 24.4783 58.2219 24.1437C64.5861 18.7894 68.6056 11.0925 69.9454 3.06109L70.2805 1.72253L70.6154 0.0493164L68.2706 1.05331Z" />
                            <path d="M4.29336 70.3246C8.31286 69.6553 12.3324 68.3168 16.0169 66.3089C19.7015 64.301 22.716 61.6238 25.3957 58.612C25.7307 58.2774 26.0657 57.6081 26.7356 56.9388C27.0706 56.6042 27.0704 56.2696 27.4054 56.2696C27.7403 55.935 27.7404 55.6003 28.0753 55.6003C28.4103 55.2656 28.7453 54.931 28.7453 54.2617L29.0802 53.9271C29.4151 53.5924 29.7503 52.9231 30.0852 52.2538C31.425 49.9113 32.0948 47.5688 33.0997 45.2263C32.0948 45.2263 30.755 45.561 29.7501 45.8956H29.4153C29.0803 45.8956 28.7453 45.8957 28.7453 46.2303C28.4103 46.2303 28.0753 46.2302 28.0753 46.5649C28.0753 46.8995 27.7405 47.2342 27.7405 47.9035C27.7405 48.2382 27.4055 48.5728 27.0705 48.9074C27.0705 49.2421 26.7355 49.5767 26.4005 49.9113V50.246C26.0656 50.5806 26.0655 50.9153 25.7306 51.25L25.3957 51.5845C25.3957 51.9192 25.0608 52.2538 25.0608 52.2538L24.7258 52.5885C24.7258 52.9232 24.3909 52.9231 24.3909 53.2577C24.3909 53.5924 24.0558 53.5924 24.0558 53.9271L23.7209 54.2617C23.386 54.5964 23.051 54.931 22.7161 55.2656C21.3762 56.9388 19.7015 58.612 17.6917 59.9506C14.6771 62.2931 11.3275 63.9663 7.64295 64.9702C9.31774 59.2813 12.6673 53.927 17.0217 50.246C18.0266 49.5767 19.0316 48.5728 20.0365 47.9035C20.7064 47.5689 21.0413 47.2342 21.7112 46.8995C22.3812 46.5649 23.0511 46.2303 23.386 45.8956H23.7209C24.0559 45.8956 24.3909 45.561 24.3909 45.561L25.0608 45.2263H25.3957C25.7307 45.2263 25.7307 44.8916 26.0657 44.8916C26.4006 44.8916 26.7356 44.5571 26.7356 44.5571L27.4054 44.2224L28.0753 43.8878H28.4104C29.7503 43.5531 31.0899 43.2184 32.4298 43.2184H32.7648H33.0997H33.7697C34.1046 43.2184 34.1047 43.2184 34.4396 43.2184C35.1096 43.2184 35.4445 43.2184 36.1144 43.2184H36.4493C36.7843 43.2184 37.1192 43.2184 37.4541 43.2184C37.1192 41.5452 37.1193 40.2067 36.7844 38.5334H36.4493C35.7794 38.5334 35.4444 38.5334 34.7745 38.5334H34.4396C34.1047 38.5334 33.7698 38.5334 33.4348 38.5334C33.0998 38.5334 32.7648 38.5334 32.7648 38.5334C32.4299 38.5334 31.7599 38.5335 31.4249 38.8681C30.42 38.8681 29.4153 39.2028 28.4104 39.5374C27.4055 39.8721 26.4007 40.2067 25.0608 40.5413C24.7259 40.5413 24.3908 40.876 24.0558 40.876L23.7209 41.2107C20.7063 42.5492 17.6917 44.2224 15.0121 46.5649C14.6771 46.8995 14.6771 46.8996 14.3421 47.2342C7.9779 52.5885 3.9584 60.2852 2.61857 68.3167L2.28349 69.6553L1.94861 71.3286L4.29336 70.3246Z" />
                            <path d="M13.3372 24.8132C17.3567 28.1596 22.0462 30.5021 26.7356 32.1754C26.7356 31.1714 26.4006 29.8329 26.0656 28.8289V28.4943C26.0656 28.1596 26.0655 28.1597 25.7305 27.825C25.7305 27.4904 25.7306 27.1557 25.3957 27.1557C22.0461 25.8171 18.6965 24.1439 16.0169 21.8014C11.3274 17.7857 8.31285 12.766 6.63806 7.07709C12.3324 8.75031 17.6916 12.0967 21.3761 16.4471C23.0509 18.4549 24.7257 20.7974 25.7305 23.1399V23.4746C25.7305 23.8092 26.0656 24.1439 26.0656 24.1439C26.0656 24.4786 26.4005 24.4785 26.4005 24.8132C26.4005 25.1478 26.7356 25.4825 26.7356 25.8172V26.1518V26.4864C26.7356 26.821 27.0704 27.1557 27.0704 27.4904C27.0704 27.825 27.0704 28.1596 27.4053 28.1596V28.4943C27.7403 29.8328 28.0753 31.1714 28.0753 32.51C28.0753 32.8447 28.0753 32.8446 28.0753 33.1792V33.8486C28.0753 34.1832 28.0753 34.1833 28.0753 34.5179C28.0753 35.1872 28.0753 35.5218 28.0753 36.1911V36.5257C28.0753 36.8603 28.0753 36.8604 28.0753 37.195C28.4102 37.195 29.0802 36.8603 29.4152 36.8603C30.0851 36.8603 30.4201 36.8603 31.09 36.5257C31.425 36.5257 31.425 36.5257 31.76 36.5257H32.0948H32.4297H33.0997C33.0997 35.8564 33.0997 35.5218 33.0997 34.8525V34.5179C33.0997 32.51 32.7647 30.1675 32.0948 28.1596C31.7599 27.1557 31.425 26.1517 31.09 24.8132C31.09 24.4785 30.7549 24.1439 30.7549 23.8093L30.42 23.1399C29.0802 19.7935 27.0704 16.4471 24.7257 13.77C19.3664 7.41174 11.6624 3.39602 3.62335 2.05744L0.608643 1.72278L0.943724 4.73455C2.95348 11.7621 7.30798 19.4589 13.3372 24.8132Z" />
                            <path d="M59.2259 46.565C55.2064 43.2186 50.517 40.8762 45.8276 39.2029C45.8276 40.2069 46.1626 41.5454 46.4975 42.5494V42.884C46.4975 43.2187 46.4977 43.2186 46.8326 43.5533C46.8326 43.8879 46.8325 44.2226 47.1675 44.2226C56.2114 47.569 63.2454 55.2659 65.9251 64.6359C57.5511 62.2934 50.517 56.2697 46.4975 48.5729V48.2383C46.4975 47.9036 46.1627 47.569 46.1627 47.569C46.1627 47.2344 45.8276 47.2344 45.8276 46.8997C45.8276 46.5651 45.4927 46.2305 45.4927 45.8958V45.5612V45.2265C45.4927 44.8918 45.1578 44.5572 45.1578 44.2226C45.1578 43.888 45.1577 43.5533 44.8228 43.5533V43.2186C44.4878 41.88 44.1528 40.5415 44.1528 39.2029C44.1528 38.8683 44.1528 38.8683 44.1528 38.5336V37.8644C44.1528 37.5297 44.1528 37.5297 44.1528 37.1951C44.1528 36.5258 44.1528 36.1911 44.1528 35.5218V35.1872C44.1528 34.8525 44.1528 34.8526 44.1528 34.5179C43.8178 34.5179 43.148 34.8525 42.8131 34.8525C42.1432 34.8525 41.8082 34.8525 41.1383 35.1872C40.8033 35.1872 40.8033 35.1872 40.4683 35.1872H40.1335H39.7984H39.1284C39.1284 35.8565 39.1284 36.1911 39.1284 36.8604V37.1951C39.1284 39.2029 39.4635 41.5454 40.1335 43.5533C40.4684 44.5572 40.8033 45.5611 41.1383 46.8997C41.1383 47.2344 41.4732 47.5691 41.4732 47.9037L41.8082 48.5729C46.4977 59.9508 56.5464 67.9823 68.6049 69.6556L71.6194 69.9901L71.2846 66.9783C69.9447 59.2815 65.5901 51.9193 59.2259 46.565Z" />
                          </svg>
                        </div>
                        Fleet
                      </a>
                    </RestrictedSection>
                  </div>
                </div>
              </ClickAwayListener>
            </RestrictedSection>
            <div
              className={`${
                HasPermission(permissionsList, 'dashboard', 'switch_app') ? 'flw-logo-div' : ''
              } d-none d-lg-block`}
            >
              <img
                onClick={() => navigate('/home')}
                className="flw-logo"
                src="https://cdn.floward.com/web/Files/attachment/artwork5_87634f18-f2b4-45c7-8dc8-227d084dd98e-copy-01-637376507120708063.svg"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="sidebar custom-scrollbar">
          {/* <UserPanel /> */}
          <ul
            className="sidebar-menu"
            id="myDIV"
            style={ulClassSidebarMenu(wrapper, layout, margin)}
          >
            <li
              className={`left-arrow ${ilClassSidebarMenu(
                layout,
                hideLeftArrowRTL,
                hideLeftArrow
              )}`}
              onClick={
                wrapper === 'horizontal_sidebar' && layout === 'rtl'
                  ? scrollToLeftRTL
                  : scrollToLeft
              }
            >
              <i className="fa fa-angle-left" />
            </li>
            {MENUITEMS.map((menuItem, i) => (
              <li className={`${menuItem.active ? 'active' : ''}`} key={i}>
                {menuItem.sidebartitle ? (
                  <div className="sidebar-title">{menuItem.sidebartitle}</div>
                ) : (
                  ''
                )}
                {menuItem.type === 'sub' && menuItem.per && (
                  <PermissionedSubMenuItem
                    per={menuItem.per}
                    clicked={() => toggletNavActive(menuItem)}
                    title={props.t(menuItem.title)}
                    Icon={menuItem.icon}
                    ticketsList={ticketsList}
                    alertQtyItems={alertQtyItems}
                    isCustomIcon={menuItem.isCustomIcon}
                  />
                )}
                {menuItem.type === 'sub' && !menuItem.per && (
                  <SubMenuItem
                    title={props.t(menuItem.title)}
                    clicked={() => toggletNavActive(menuItem)}
                    Icon={menuItem.icon}
                    isCustomIcon={menuItem.isCustomIcon}
                  />
                )}
                {menuItem.type === 'link' && menuItem.per && (
                  <PermissionedMenuItem
                    path={menuItem.path}
                    active={menuItem.active}
                    clicked={() => toggletNavActive(menuItem)}
                    Icon={menuItem.icon}
                    title={props.t(menuItem.title)}
                    per={menuItem.per}
                    isCustomIcon={menuItem.isCustomIcon}
                  />
                )}
                {menuItem.children ? (
                  <ul
                    className={`sidebar-submenu ${menuItem.active ? 'menu-open' : ''}`}
                    style={
                      menuItem.active ? { opacity: 1, transition: 'opacity 500ms ease-in' } : {}
                    }
                  >
                    {menuItem.children.map((childrenItem, index) => (
                      <li
                        key={index}
                        className={childrenItem.children && childrenItem.active ? 'active' : ''}
                      >
                        {childrenItem.type === 'sub' && !childrenItem.action && (
                          <SubMenuItem
                            clicked={() => toggletNavActive(childrenItem)}
                            Icon={childrenItem.icon}
                            title={props.t(childrenItem.title)}
                            isSubChild
                          />
                        )}
                        {childrenItem.type === 'sub' && childrenItem.action && (
                          <PermissionedSubSubMenu
                            per={childrenItem.per}
                            action={childrenItem.action}
                            clicked={() => toggletNavActive(childrenItem)}
                            title={props.t(childrenItem.title)}
                            Icon={childrenItem.icon}
                          />
                        )}
                        {childrenItem.type === 'link' && childrenItem.per && (
                          <PermissionedMenuItem
                            per={childrenItem.per}
                            action={childrenItem.action}
                            path={getMenuItemPath(childrenItem)}
                            active={childrenItem.active}
                            isCustomIcon
                            Icon={childrenItem.icon}
                            title={props.t(childrenItem.title)}
                            clicked={() => {
                              toggletNavActive(childrenItem);
                              if (childrenItem.orderStatus) {
                                if (childrenItem.orderProdType) {
                                  handleParamsUrl(+childrenItem.orderStatus, true);
                                } else {
                                  handleParamsUrl(+childrenItem.orderStatus, false);
                                }
                              } else if (childrenItem.prodLine >= 0) {
                                handleProdLine(+childrenItem.prodLine);
                              } else if (childrenItem.inventoryStatus >= 0) {
                                handleInventoryStatus(+childrenItem.inventoryStatus);
                              } else if (childrenItem.categoryType) {
                                handleCategoryParams(+childrenItem.categoryType);
                              } else if (childrenItem.mbsOrders === true) {
                                handleMbsOrdersParams();
                              } else if (childrenItem.preOrders === true) {
                                handlePreOrdersParams();
                              }
                            }}
                            isChild
                            alertQtyItems={alertQtyItems}
                            centerType={
                              getFromLocalStorage(localStorageKeys.OPS_CENTER)?.centerType
                            }
                          />
                        )}
                        {childrenItem.type === 'link' && !childrenItem.per && (
                          <MenuItem
                            path={childrenItem.path}
                            active={childrenItem.active}
                            clicked={() => {
                              toggletNavActive(childrenItem);
                              if (childrenItem.orderProdType) {
                                handleParamsUrl(2, true);
                              } else {
                                handleParamsUrl(2, false);
                              }
                            }}
                            Icon="fa-rocket"
                            title={props.t(childrenItem.title)}
                            isCustomIcon
                            isChild
                          />
                        )}
                        {childrenItem.children ? (
                          <ul
                            className={`sidebar-submenu ${
                              childrenItem.active ? 'menu-open' : 'active'
                            }`}
                          >
                            {childrenItem.children.map((childrenSubItem, key) => (
                              <li className={childrenSubItem.active ? 'active' : ''} key={key}>
                                {childrenSubItem.type === 'link' && (
                                  <MenuItem
                                    path={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
                                    active={childrenSubItem.active}
                                    clicked={() => {
                                      toggletNavActive(childrenSubItem);
                                    }}
                                    Icon="fa-circle"
                                    title={props.t(childrenSubItem.title)}
                                    isCustomIcon
                                    isChild
                                    childOfChild
                                  />
                                )}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          ''
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  ''
                )}
              </li>
            ))}
            <li
              className={`right-arrow ${ilClassSidebarMenu(
                layout,
                hideLeftArrowRTL,
                hideLeftArrow
              )}`}
              onClick={
                wrapper === 'horizontal_sidebar' && layout === 'rtl'
                  ? scrollToRightRTL
                  : scrollToRight
              }
            >
              <i className="fa fa-angle-right"></i>
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default translate(Sidebar);
